import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/create')({
  component: CreateComponent,
})

function CreateComponent() {
  return (
    <div className="p-2">
      <h3>Create</h3>
    </div>
  )
}
